import type { ComponentType } from 'react'
import type { AdminSectionContribution, AdminSectionProps } from '@os/contracts/web'
import { MODULE_CATALOG } from '@os/contracts/shared'
import { MODULE_UI_META } from '../utils/moduleUiMeta'

// lucide icons are ForwardRefExoticComponent and don't satisfy
// ComponentType<{size?:number}> under strict TS; cast is safe (every icon
// takes `size`). Same pattern as platformAdminModule.tsx.
type Icon = ComponentType<{ size?: number }>

// One default GLOBAL admin section per catalog module. Component = the
// adoption + control panel. order = catalog index (Modules group keeps
// catalog order). An explicit contribution carrying the same moduleKey
// overrides this default slot (see getGroupedPlatformSections).
export function buildPlatformModuleDefaults(): AdminSectionContribution[] {
  return MODULE_CATALOG.map((m, i) => ({
    id: `module:${m.key}`,
    label: m.label,
    scope: 'platform',
    order: i,
    moduleKey: m.key,
    gate: { globalAdmin: true },
    icon: MODULE_UI_META[m.key]?.icon as unknown as Icon,
    component: async () => {
      const { default: ModuleAdoptionPanel } = await import('../components/admin/modules/ModuleAdoptionPanel')
      return { default: () => <ModuleAdoptionPanel moduleKey={m.key} /> }
    },
  } satisfies AdminSectionContribution))
}

// One default per catalog module for the SERVER shell. Component =
// ModulePlaceholder. gate serverOwner (owner + global admin). Enabled-for-
// server filtering happens in getGroupedServerSections, not here.
export function buildServerModuleDefaults(): AdminSectionContribution[] {
  return MODULE_CATALOG.map((m, i) => ({
    id: `module:${m.key}`,
    label: m.label,
    scope: 'server',
    order: i,
    moduleKey: m.key,
    gate: { serverOwner: true },
    icon: MODULE_UI_META[m.key]?.icon as unknown as Icon,
    component: async () => {
      const { default: ModulePlaceholder } = await import('../components/admin/modules/ModulePlaceholder')
      return { default: ({ serverId }: AdminSectionProps) => <ModulePlaceholder moduleKey={m.key} serverId={serverId} /> }
    },
  } satisfies AdminSectionContribution))
}
